// /src/AppContent.js
import React, { useState, useEffect } from "react";
import { useSupabaseAuth } from "./contexts/SupabaseAuthContext";
import { useProfile } from "./contexts/ProfileContext";
import ProfileSelection from "./components/ProfileSelection";
import ProfileAvatar from "./components/ProfileAvatar";
import DialogApp from "./DialogApp";
import AuthScreen from "./components/AuthScreen";
import { useNavigate } from "react-router-dom";

// The main component that decides what to render based on user & selectedProfile
function AppContent() {
  const { user, loading: authLoading } = useSupabaseAuth();
  const { selectedProfile, loading: profileLoading } = useProfile();
  const [showManageOwners, setShowManageOwners] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (selectedProfile && selectedProfile.intro_done === false) {
      navigate("/intro");
    }
  }, [selectedProfile, navigate]);

  if (authLoading || profileLoading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <span className="loading loading-spinner loading-lg text-primary"></span>
      </div>
    );
  }

  // If no user, show sign-in screen
  if (!user) {
    return <AuthScreen />;
  }

  // If user is logged in but hasn't chosen a profile, show the selection
  if (!selectedProfile) {
    return <ProfileSelection />;
  }

  // If intro is not done, the useEffect will redirect to /intro
  // This is a failsafe if for some reason the redirect didn't happen
  if (selectedProfile.intro_done === false) {
    return null;
  }

  // If user + profile are set, show the main app screen
  return (
    <MainApp
      user={user}
      profile={selectedProfile}
      showManageOwners={showManageOwners}
      setShowManageOwners={setShowManageOwners}
    />
  );
}

/** Your main app UI after a user + profile are selected */
function MainApp({ user, profile, showManageOwners, setShowManageOwners }) {
  return (
    <div className="h-screen w-full flex flex-col">
      {/* Top avatar menu - positioned absolutely to avoid taking up layout space */}
      <div className="absolute top-0 right-0 z-10">
        <ProfileAvatar
          profile={profile}
          showManageOwners={showManageOwners}
          setShowManageOwners={setShowManageOwners}
          userId={user.id}
        />
      </div>

      {/* Main content area - now takes full height */}
      <div className="h-full w-full flex items-center justify-center">
        <DialogApp />
      </div>
    </div>
  );
}

export default AppContent;
